import React, { Component } from 'react';
import { InspectorMonitor, } from '@redux-devtools/inspector-monitor';
import { TraceTab } from '@redux-devtools/inspector-monitor-trace-tab';
import { TestTab } from '@redux-devtools/inspector-monitor-test-tab';
import { DATA_TYPE_KEY } from '../../../constants/dataTypes.js';
import SubTabs from './SubTabs.js';
const DEFAULT_TABS = [
    {
        name: 'Action',
        component: SubTabs,
    },
    {
        name: 'State',
        component: SubTabs,
    },
    {
        name: 'Diff',
        component: SubTabs,
    },
    {
        name: 'Trace',
        component: TraceTab,
    },
];
class InspectorWrapper extends Component {
    render() {
        const { features, ...rest } = this.props;
        let tabs;
        if (features && features.test) {
            tabs = () => [
                ...DEFAULT_TABS,
                { name: 'Test', component: TestTab },
            ];
        }
        else {
            tabs = () => DEFAULT_TABS;
        }
        return (React.createElement(InspectorMonitor, { dataTypeKey: DATA_TYPE_KEY, invertTheme: false, tabs: tabs, hideActionButtons: !features.skip, hideMainButtons: true, ...rest }));
    }
}
InspectorWrapper.update = InspectorMonitor.update;
export default InspectorWrapper;
